import * as t from "../actions";
import * as _ from "lodash";

const initialStructureState: IStructureState = {
  dimensions: [],
  metrics: []
};

function immutableMove(arr: any, oldIndex: number, newIndex: number) {
  let obj = arr[oldIndex];
  let copy = [
    ...arr.slice(0, oldIndex),
    ...arr.slice(oldIndex + 1, arr.length)
  ];
  copy.splice(newIndex, 0, obj);
  return copy;
}

export default function (state = initialStructureState, action: IPayload) {
  switch (action.type) {
    case t.ADD_DIMENSION:
      const dimension: any = _.pickBy(
        action.payload,
        (v, k) => k === "id" || k === "name"
      );

      return {
        ...state,
        dimensions: state.dimensions.concat(dimension)
      };

    case t.REMOVE_DIMENSION:
      return {
        ...state,
        dimensions: state.dimensions.filter((m) => m.id !== action.payload.id)
      };

    case t.REORDER_DIMENSION:
      var { fromIndex, toIndex } = action.payload;

      return {
        ...state,
        dimensions: immutableMove(state.dimensions, fromIndex, toIndex)
      };

    case t.ADD_METRIC:
      const metric: any = _.pickBy(
        action.payload,
        (v, k) => k === "id" || k === "name"
      );

      return {
        ...state,
        metrics: state.metrics.concat(metric)
      };

    case t.REMOVE_METRIC:
      return {
        ...state,
        metrics: state.metrics.filter((m) => m.id !== action.payload.id)
      };

    case t.REORDER_METRIC:
      var { fromIndex, toIndex } = action.payload;

      return {
        ...state,
        metrics: immutableMove(state.metrics, fromIndex, toIndex)
      };

    case t.ADD_REPORT:
      return {
        dimensions: action.payload.dimensions,
        metrics: action.payload.metrics
      };

    case t.FLUSH_REPORT:
      return initialStructureState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/structure.ts